<template>
  <div class="page_">
    版权帮助中心
    <marketingPageFooter></marketingPageFooter>
  </div>
</template>

<script>
import { reactive } from "vue";
import marketingPageFooter from '@/components/marketingPageFooter.vue'
// import { useRoute, useRouter } from "vue-router";
// import { useStore } from "vuex";
// import Cookies from "js-cookie";

export default {
  name: "copyrightHelpCentre",
  components:{
    marketingPageFooter
  },
  setup(prop) {
    console.log(prop);
    // const route = useRoute();
    // const router = useRouter();
    // const store = useStore();
    let pageData = reactive({

    })
    return {
      pageData
    };
  },
};
</script>
<style lang='scss' scoped>
.page_ {

}
</style>
